// extracted by mini-css-extract-plugin
export default {"circle":"ProgressBarItem_circle__3olCO","item":"ProgressBarItem_item__3tr5X"};